function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 42,
  rx: 21,
  fill: "#FA6358",
  fillOpacity: 0.15
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.153 20.047h4.32c.82 0 1.49-.608 1.49-1.351V15.35c0-.743-.67-1.351-1.49-1.351h-5.81c-3.687 0-6.63 2.703-6.63 6.014v4.594c0 .203-.149.338-.372.338H22.49c-.82 0-1.49.608-1.49 1.351v3.345c0 .743.67 1.351 1.49 1.351h4.171c.223 0 .372.135.372.338V42.65c0 .743.67 1.351 1.49 1.351h3.687c.82 0 1.49-.608 1.49-1.351V31.33c0-.203.15-.338.373-.338h5.437c.82 0 1.49-.608 1.49-1.351v-3.345c0-.743-.67-1.351-1.49-1.351h-5.475c-.223 0-.372-.135-.372-.338v-3.21c0-.743.67-1.35 1.49-1.35z",
  fill: "#444"
});

function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgFacebookinline;